module.exports = __webpack_public_path__ + "static/media/20201219_112731_898_IMG_3354.b62df08e.jpg";